import React from 'react';
import SkeletonLoader from './SkeletonLoader';

const ProductSkeleton = ({ view = 'grid', count = 6 }) => {
  const renderProductCard = () => (
    <div className="skeleton-product-card">
      <div className="skeleton-product-image skeleton-loader"></div>
      <div className="skeleton-product-body">
        <div className="skeleton-product-title skeleton-loader"></div>
        <div className="skeleton-product-brand skeleton-loader"></div>
        <div className="skeleton-product-price skeleton-loader"></div>
        <div className="skeleton-product-shipping skeleton-loader"></div>
      </div>
    </div>
  );

  if (view === 'slider') {
    return (
      <div className="skeleton-slider-container">
        <div className="skeleton-slider-wrapper">
          {Array.from({ length: count }).map((_, index) => (
            <div key={index} className="skeleton-slider-item">
              {renderProductCard()}
            </div>
          ))}
        </div>
      </div>
    );
  }

  return (
    <div className="skeleton-product-grid">
      {Array.from({ length: count }).map((_, index) => (
        <div key={index}>
          {renderProductCard()}
        </div>
      ))}
    </div>
  );
};

export default ProductSkeleton; 